export default "__VITE_ASSET__749fc862__"